export default __webpack_public_path__ + "static/media/Fees Collected.54f9aeee.png";